import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { withTitle } from '../../HOC';
import useLongformGallery from './useLongformGallery';
import LongformGalleryImage from './LongformGalleryImage';
const LongformGallery = props => {
  const {
    loading,
    error,
    groupedImages,
    shouldDisplayCaption,
    caption,
    handleImageOnClick
  } = useLongformGallery(props);
  if (loading || error || !groupedImages.length) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "longform-gallery",
    "data-testid": "longform-gallery"
  }, groupedImages.map((imageGroup, i) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement("div", {
    key: i,
    "data-testid": "grouped-images",
    className: "longform-gallery__images"
  }, imageGroup.map(secondaryImage => /*#__PURE__*/React.createElement(LongformGalleryImage, _extends({
    key: secondaryImage.id
  }, secondaryImage, {
    numberOfImages: imageGroup.length,
    className: imageGroup.length > 2 ? 'longform-gallery__images__image secondary-image' : 'longform-gallery__images__image main-image',
    handleImageOnClick: handleImageOnClick
  }))))), shouldDisplayCaption && /*#__PURE__*/React.createElement("div", {
    className: "carousel__details",
    "data-testid": "carousel-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "caption"
  }, caption)));
};
export default withTitle(LongformGallery);
//# sourceMappingURL=LongformGallery.js.map